import React from "react";
import { X as XIcon } from "lucide-react";
import { Button } from "../../../../components/UI/Button";
import type { Courier } from "../../../../../domain/types/orders";

interface ShippingDialogProps {
  isOpen: boolean;
  courier: string;
  trackingNumber: string;
  courierList: Courier[];
  isLoading: boolean;
  onCourierChange: (courier: string) => void;
  onTrackingNumberChange: (trackingNumber: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export const ShippingDialog: React.FC<ShippingDialogProps> = ({
  isOpen,
  courier,
  trackingNumber,
  courierList,
  isLoading,
  onCourierChange,
  onTrackingNumberChange,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-[0.625rem] max-w-md w-full p-6 m-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">출고/배송 처리</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XIcon className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label
              htmlFor="shipping-courier"
              className="block text-sm font-medium mb-2 text-left"
            >
              택배사 (선택사항)
            </label>
            <select
              id="shipping-courier"
              value={courier}
              onChange={(e) => onCourierChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white cursor-pointer"
              disabled={isLoading}
            >
              <option value="">
                {isLoading ? "택배사 목록 로딩중..." : "택배사를 선택하세요"}
              </option>
              {courierList.map((c) => (
                <option key={c.code} value={c.name}>
                  {c.title}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              htmlFor="shipping-tracking-number"
              className="block text-sm font-medium mb-2 text-left"
            >
              송장번호 (선택사항)
            </label>
            <input
              type="text"
              id="shipping-tracking-number"
              placeholder="송장번호를 입력하세요"
              value={trackingNumber}
              onChange={(e) => onTrackingNumberChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <Button variant="outline" onClick={onClose}>
            취소
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-[#4CAF50] hover:bg-[#45a049] text-white"
          >
            출고/배송 처리
          </Button>
        </div>
      </div>
    </div>
  );
};
